import { render, staticRenderFns } from "./InputSugestaoFilial.vue?vue&type=template&id=6df0a192&"
import script from "./InputSugestaoFilial.vue?vue&type=script&lang=js&"
export * from "./InputSugestaoFilial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports